/**
 * Central route table for the console-ui SPA.
 *
 * Two surfaces share one SPA:
 *   - Public marketing pages (Manifold Kinetics brand)
 *   - Authenticated console (RoboTwins core + Manifold Kinetics pillars)
 *
 * Route builders keep callers from hand-assembling path strings.
 */

export const PUBLIC_ROUTES = {
  landing: "/",
  about: "/about",
  login: "/login",
  signup: "/signup",
  maternal: "/maternal",
  agedCare: "/aged-care",
  robotwins: "/robotwins",
  essentials: "/essentials",
  howItWorks: "/how-it-works",
  productScanToSim: "/product/scan-to-sim",
  productIntelligenceCore: "/product/intelligence-core",
  productEdgeReflex: "/product/edge-reflex",
  productLocalMind: "/product/local-mind",
  nightShift: "/night-shift",
  compliance: "/compliance",
  contact: "/contact",
} as const;

export const APP_ROUTES = {
  dashboard: "/dashboard",
  project: (id: string) => `/projects/${id}`,
  scan: (id: string) => `/projects/${id}/scan`,
  environment: (id: string, envId: string) =>
    `/projects/${id}/environment/${envId}`,
  training: (id: string) => `/projects/${id}/training`,
  deploy: (id: string) => `/projects/${id}/deploy`,
  evidence: (id: string, deploymentId: string) =>
    `/projects/${id}/deploy/${deploymentId}/evidence`,
  intent: (id: string) => `/projects/${id}/intent`,
  intentPlan: (id: string, planId: string) =>
    `/projects/${id}/intent/${planId}`,
  edge: (id: string) => `/projects/${id}/edge`,
  edgeRobot: (id: string, robotId: string) =>
    `/projects/${id}/edge/${robotId}`,
  egress: (id: string) => `/projects/${id}/egress`,
  compliance: (id: string) => `/projects/${id}/compliance`,
  complianceEvent: (id: string, eventId: string) =>
    `/projects/${id}/compliance/${eventId}`,
} as const;

export const PROJECT_NAV_ITEMS = [
  { suffix: "", label: "Overview", icon: "grid" },
  { suffix: "/scan", label: "Scan & Upload", icon: "upload" },
  { suffix: "/training", label: "Training", icon: "cpu" },
  { suffix: "/deploy", label: "Deployment", icon: "send" },
] as const;

export const MANIFOLD_NAV_ITEMS = [
  { suffix: "/intent", label: "Intent Plans", icon: "brain", pillar: "A" },
  { suffix: "/edge", label: "Edge Reflex", icon: "bolt", pillar: "C" },
  { suffix: "/compliance", label: "Compliance Ledger", icon: "shield" },
] as const;
